module.exports = __webpack_public_path__ + "static/50week-eb4d611dcc1169211613ccdaef4888d5.png";